import { action, makeObservable } from 'mobx';
import {ChangeEventHandler} from 'react';
import {Control} from './Control';

export class BooleanControl extends Control<boolean> {
  @action
  onChangeHandler: ChangeEventHandler<HTMLInputElement> =
    (event) => {
      this.setValue(event.target.checked);
    };

//   constructor(readonly name: string,
//     initialValue: boolean) {
//     // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
//     super(name, initialValue);

//     makeObservable(this);
//   }
}
